<template>
    <div class="prizeSelector">
        <action-builder-prize-selector-row
            v-for="(prize, i) in prizeList"
            :key="`prize_${i}`"
            :index="i"
            :prize="prize"
            :availablePrizes="availablePrizes"
            @remove="onRemovePrize"
        />

        <button class="prizeSelector__add" v-if="prizesAdded.length < 3" @click="onAddClick">Add an other prize</button>
    </div>
</template>

<script>
import EventBus from '../../EventBus.vue'
import ActionBuilderPrizeSelectorRow from './ActionBuilderPrizeSelectorRow.vue'

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'ActionBuilderPrizeSelector',

    components: {
        ActionBuilderPrizeSelectorRow,
    },

    props: {
        availablePrizes: {
            type: Array,
            required: true,
        },
        prizesAdded: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            prizeList: this.prizesAdded,
        }
    },




    /* Life Cycle
    --------------------------------------------------------- */

    created() {
    },


    mounted() {
        // add default first prize if no prizes added
        if (this.prizeList.length === 0) {
            this.addRow()
        }
    },




    /* Data Handling
    --------------------------------------------------------- */

    computed: {
    },


    watch: {
        //
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {
        addRow() {
            this.prizeList.push({
                type: 'product',
                id: null,
                label: null,
            })
            this.$nextTick(() => {
                EventBus.$emit('actionbuilder-update', { method: 'POST' })
            })
        },

        onAddClick(e) {
            e.preventDefault()
            this.addRow()
        },

        onRemovePrize(i) {
            this.prizeList.splice(i, 1)
            this.$nextTick(() => {
                EventBus.$emit('actionbuilder-update', { method: 'POST' })
            })
        },

    },


}

</script>
